import React, { FunctionComponent } from 'react'
import { List } from 'antd'
import TripHistoryItem from './TripHistoryItem/TripHistoryItem'

export interface Trip {
  sample_time: string
  trip_id: number
  unit_name: string
  sim_id: string
}

interface IProps {
  trips: Trip[]
  tripsLoading: boolean
}

const TripHistoryList: FunctionComponent<any> = (props: IProps) => {
  const { trips, tripsLoading } = props

  const renderItem = (item: Trip) => <TripHistoryItem trip={item} />

  return <List loading={tripsLoading} style={{ width: '100%' }} dataSource={trips} renderItem={renderItem} size={'small'} />
}

export default TripHistoryList
